import { Helmet } from 'react-helmet';

export default function Clients() {
    return (
        <>
            <Helmet>
                <title>Clients | A. Page Code</title>
                <meta name="description" content="Basic example" />
            </Helmet>
            <h1>Client List</h1>
        </>
    );
}